export const Highlight1 = require('../assets/001146_-_Goal.mp4');
export const Highlight2 = require('../assets/001820_-_Gol.mp4');
export const Highlight3 = require('../assets/002058_-_Goal.mp4');
export const Highlight4 = require('../assets/004705_-_Goal.mp4');
